import { defineComponent as _defineComponent } from 'vue'
import { useRirekishoPreview } from '@/composables/format-edit/useRirekishoPreview'

type FormatPreviewSfcProps = {
  formatData: Record<string, any>
  basicData: Record<string, any>
  previewScale?: number
  currentCardId?: string | string[]
  idPrefix?: string
  isSample?: boolean
}


export default /*#__PURE__*/_defineComponent({
  __name: 'NewRirekishoPreview',
  props: {
    formatData: null,
    basicData: null,
    previewScale: { default: 1 },
    currentCardId: { default: '' },
    idPrefix: { default: '' },
    isSample: { type: Boolean, default: false }
  },
  setup(__props: any, { expose }) {

const props = __props as { formatData: Record<string, any>, basicData: Record<string, any>, previewScale: number, currentCardId: string | string[], idPrefix: string, isSample: boolean };



const {
  checkValid,
  formLib,
  scaleStyle,
  highlightMessage,
  goCardTo,
  highLightClass,
  classObject,
  errorMessages,
  tel,
  contactTel,
  age,
  formatedCreateDate,
  isMale,
  isFemale,
  isGenderDisplay,
  eduJobHistoryTable4New,
  licenseHistoryTable
} = useRirekishoPreview(props, {
  maxEduJobRows: 11,
  maxLicenseRows: 5,
  textareaMaxHeights: { reason: 710, reasonNew: 710, request: 100 },
  useEduJobTable4New: true
})

expose({ checkValid })

return { __sfc: true,props, checkValid, formLib, scaleStyle, highlightMessage, goCardTo, highLightClass, classObject, errorMessages, tel, contactTel, age, formatedCreateDate, isMale, isFemale, isGenderDisplay, eduJobHistoryTable4New, licenseHistoryTable }
}

})